import axios from 'axios';
import { CUSTOMER_API_URL } from '../constants';
import {
  PlanGroupApiResponseType,
  PlanGroupPlanType,
  PlanGroupsStateType,
} from '../types/api/PlanGroupApiType';
import { extractPlanGroupId } from './subscriptionDetail/utils';

/**
 * プラングループ取得APIを呼び、結果を「プラングループID → plans のみ」の形で返す。
 * 画面側（use-subscription-detail）で「この商品はどのプランで買えるか」を調べるときに使う。
 */
export async function getPlanGroups(token: string): Promise<PlanGroupsStateType> {
  const response = await axios.post<PlanGroupApiResponseType>(
    `${CUSTOMER_API_URL}?action=getPlanGroups`,
    {},
    { headers: { Authorization: token } }
  );
  const data = response.data;
  // 実際のレスポンスは配列がそのまま返る
  if (!Array.isArray(data)) return {};
  const planGroupArray = data;

  const result: PlanGroupsStateType = {};
  for (const item of planGroupArray) {
    const id = extractPlanGroupId(item.planGroupId);
    if (!id) continue;
    // plans から name, description を除いた形に変換。discountTimes は使用するため含める
    const plansOnly: PlanGroupPlanType[] = item.plans.map((p) => ({
      planId: p.planId,
      billingPolicyInterval: p.billingPolicyInterval,
      billingPolicyIntervalCount: p.billingPolicyIntervalCount,
      pricingPolicyAdjustmentType: p.pricingPolicyAdjustmentType,
      pricingPolicyAdjustmentValue: p.pricingPolicyAdjustmentValue,
      firstPricingPolicyAdjustmentType: p.firstPricingPolicyAdjustmentType,
      firstPricingPolicyAdjustmentValue: p.firstPricingPolicyAdjustmentValue,
      billingPolicyMinCycles: p.billingPolicyMinCycles,
      billingPolicyMaxCycles: p.billingPolicyMaxCycles,
      discountTimes: p.discountTimes ?? [],
    }));
    result[id] = plansOnly;
  }
  return result;
}
